<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: luoxi
 * @Date: 
 * @LastEditors: wanglong
 * @LastEditTime: 2021-07-07 14:14:40
 -->
<template>
  <ul class="part10">
    <div class="title">所要参加的活动总览 Overview of activities to be attended</div>
    <li>
      <el-input
        placeholder="请输入内容"
        v-model="part10.activityChorusCh"
        :disabled="stateCode==6||stateCode==0?false:true"
      >
        <template slot="prepend">合唱团名称：</template>
      </el-input>
    </li>
    <li>
      <el-input
        placeholder="请输入内容"
        v-model="part10.activityChorusEn"
        :disabled="stateCode==6||stateCode==0?false:true"
      >
        <template slot="prepend">Name of the group：</template>
      </el-input>
    </li>
    <div class="text">
      <p>
        我们希望参加世界合唱比赛的以下活动
        <br />
        <span>（在每个比赛阶段，每个合唱团和指挥最多可以报名参加两项活动）</span>
      </p>
      <p>
        We want to participate in the following activities of the World Choir
        Games
        <br />
        <span>
          (choirs and conductors may register for a maximum of 2 activities per
          part)
        </span>
      </p>
    </div>
    <ul class="lis">
      <li>
        <el-checkbox
          v-model="part10.activityChampion"
          :disabled="stateCode==6||stateCode==0?false:true"
        >世界合唱比赛—冠军赛（请填写表格 AⅠ）</el-checkbox>
      </li>
      <li>
        <el-checkbox v-model="part10.activityChampion" :disabled="stateCode==6||stateCode==0?false:true">
          World Choir Games – The Champions Competition (Please fill in forms
          AI)
        </el-checkbox>
      </li>
      <li>
        <el-checkbox
          v-model="part10.activityOpen"
          :disabled="stateCode==6||stateCode==0?false:true"
        >世界合唱比赛—公开赛（请填写表格 AⅡ）</el-checkbox>
      </li>
      <li>
        <el-checkbox v-model="part10.activityOpen" :disabled="stateCode==6||stateCode==0?false:true">
          World Choir Games – The Open Competition (Please fill in forms
          AII)
        </el-checkbox>
      </li>
      <li>
        <el-checkbox
          v-model="part10.activityComment"
          :disabled="stateCode==6||stateCode==0?false:true"
        >不参赛合唱团的点评表演（请填写表格 B）</el-checkbox>
      </li>
      <li>
        <el-checkbox v-model="part10.activityComment" :disabled="stateCode==6||stateCode==0?false:true">
          Evaluation Performance for non-competing choirs (Please fill in form
          B)
        </el-checkbox>
      </li>
      <li>
        <el-checkbox
          v-model="part10.activityTutorial"
          :disabled="stateCode==6||stateCode==0?false:true"
        >个别指导（请填写表格 B）</el-checkbox>
      </li>
      <li>
        <el-checkbox
          v-model="part10.activityTutorial"
          :disabled="stateCode==6||stateCode==0?false:true"
        >Individual Coaching (Please fill in form B)</el-checkbox>
      </li>
      <li>
        <el-checkbox
          v-model="part10.activityConclude"
          :disabled="stateCode==6||stateCode==0?false:true"
        >节日舞台合唱团—参加 2020 年 7 月 15 日的闭幕式演出</el-checkbox>
      </li>
      <li>
        <el-checkbox
          v-model="part10.activityConclude"
          :disabled="stateCode==6||stateCode==0?false:true"
        >Festival Stage Choir – Closing Ceremony on July 15, 2020</el-checkbox>
      </li>
      <li>
        <el-checkbox v-model="part10.activityABDFriend" :disabled="stateCode==6||stateCode==0?false:true">
          在参加 A、B 或 D 之外，还参加友好音乐会演出（请填写表格
          C）
        </el-checkbox>
      </li>
      <li>
        <el-checkbox v-model="part10.activityABDFriend" :disabled="stateCode==6||stateCode==0?false:true">
          Friendship Concert Performance in addition to participation in A, B
          or D (Please fill in form C)
        </el-checkbox>
      </li>
      <li>
        <el-checkbox
          v-model="part10.activityFriend"
          :disabled="stateCode==6||stateCode==0?false:true"
        >只参加友好音乐会演出（请填写表格 C）</el-checkbox>
      </li>
      <li>
        <el-checkbox v-model="part10.activityFriend" :disabled="stateCode==6||stateCode==0?false:true">
          Friendship Concert Performances only (Please fill in form
          C)
        </el-checkbox>
      </li>
    </ul>
  </ul>
</template>

<script>
export default {
  props: {
    activitiesh: {
      type: Object,
      default() {
        return {
          type: 0,
          data: null,
        };
      },
    },
    stateCode: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  components: {},
  computed: {},
  data() {
    return {
      checked: false,
      part10: {
        activityChorusCh: "", // 合唱团名称
        activityChorusEn: "",
        activityChampion: false, // 世界合唱比赛—冠军赛（请填写表格 AⅠ）
        activityOpen: false, // 世界合唱比赛—公开赛（请填写表格 AⅡ）
        activityComment: false, // 不参赛合唱团的点评表演（请填写表格 B）
        activityTutorial: false, //个别指导（请填写表格 B）
        activityConclude: false, //节日舞台合唱团—参加 2020 年 7 月 14 日的闭幕式演出
        activityABDFriend: false, //在参加 A、B 或 D 之外，还参加友好音乐会演出（请填写表格 C）
        activityFriend: false, //只参加友好音乐会演出（请填写表格 C）
      },
    };
  },

  created() {},
  mounted() {
    this.getdetails();
  },
  methods: {
    getdetails() {
      this.part10.activityChorusCh = this.activitiesh.activityChorusCh;
      this.part10.activityChorusEn = this.activitiesh.activityChorusEn;
      this.part10.activityChampion = this.activitiesh.activityChampion;
      this.part10.activityOpen = this.activitiesh.activityOpen;
      this.part10.activityComment = this.activitiesh.activityComment;
      this.part10.activityTutorial = this.activitiesh.activityTutorial;
      this.part10.activityConclude = this.activitiesh.activityConclude;
      this.part10.activityABDFriend = this.activitiesh.activityABDFriend;
      this.part10.activityFriend = this.activitiesh.activityFriend;
    },
  },
};
</script>

<style scoped="" lang="scss">
.part10 {
  .title {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #3c4353;
    margin: 48px 48px;
  }
  .lis {
    li {
      border: 1px solid gainsboro;
      margin-left: 100px;
      margin-right: 100px;
      padding-left: 10px;
      padding-right: 0px;
      .el-checkbox {
        line-height: 34px;
        /deep/.el-checkbox__label {
          color: rgba(36, 85, 139, 1);
          input {
            outline: none;
            border: 0;
            border-bottom: 1px solid gray;
          }
        }
      }
    }
  }
  .text {
    margin: auto;
    margin-left: 100px;
    margin-right: 100px;
    line-height: 40px;
    margin-top: 46px;
    p {
      font-size: 24px;
      span {
        font-size: 24px;
        color: rgba(252, 82, 76, 1);
      }
    }
  }
  li {
    display: flex;
    padding-left: 100px;
    padding-right: 100px;
    margin-top: 20px;

    .el-input {
      /deep/ .el-input-group__prepend {
        border-right: 0;
        color: rgba(36, 85, 139, 1);
        background: white;
        padding-right: 0px;
      }
      /deep/.el-input__inner {
        border-left: 0;
        padding: 0 15px 0 0;
        &:focus {
          border-color: #dcdfe6;
          outline: 0;
        }
      }
    }

    .radiobox {
      width: 30%;
      border: 1px solid gainsboro;
      .el-radio {
        margin-left: 30px;
        margin-top: 14px;
      }
    }
    p {
      color: rgba(36, 85, 139, 1);
      line-height: 32px;
    }
  }

  li:nth-of-type(3) {
    margin-top: 30px;
  }

  li:nth-of-type(5) {
    margin-top: 30px;
  }
  li:nth-of-type(7) {
    margin-top: 30px;
  }
  li:nth-of-type(9) {
    margin-top: 30px;
  }
  li:nth-of-type(11) {
    margin-top: 30px;
  }
  li:nth-of-type(13) {
    margin-top: 30px;
  }
}
</style>
